<template>
  <layout-panel :class="['question-panel', indexe.isJumped?'jump':'']"
                :collapse="!showBody">
    <!-- 面板标题 -->
    <template slot="header">
      <span @click="console(question)">
        Q{{questionIndex+1}} {{types[question.type]}}
        <span v-show="indexe.isJumped">(已跳过)</span>
        <span v-if="page.modifyAnswerQuestions[question.id]===true"
              class="color-danger">审核员修改过答案</span>
      </span>
    </template>
    <template slot="tools"></template>
    <!-- 题目标题 -->
    <div class="question-title">
      <span class="question-title-text" v-html="question.title"></span>
    </div>
    <div class="question-audit-text" v-if="question.auditText">
      <b style="color:#f56c6c">审单须知：</b>
      <span v-html="question.auditText"></span>
    </div>
    <!-- 题目信息 -->
    <question-detail
      :question="question"
      :question-index="questionIndex"/>
    <!-- 题目选项 -->
    <question-option
      v-if="question.options"
      :question="question"
      :question-index="questionIndex"
      :answer="answer"
      :disabled="disabled"
      @change="answerChange">
      <el-tag slot="append"
              slot-scope="prop"
              type="info"
              size="mini"
              v-if="page.questionMatchProduct[question.id]
              && page.questionMatchProduct[question.id].options[prop.option.id]
              && page.questionMatchProduct[question.id].options[prop.option.id].matched">
        {{page.questionMatchProduct[question.id].options[prop.option.id].matched}}
      </el-tag>
    </question-option>
    <!-- 题目文本答案 -->
    <div style="margin-bottom: 12px" v-if="answer.hasOwnProperty('text')">
      <div class="answer-title">
        文本答案
      </div>
      <answer-text
        :answer="answer"
        @change="answerChange"
        @input="answerTextChange"
        :disabled="disabled"/>
    </div>
    <!-- 题目证据答案 -->
    <div class="answer-content">
      <div class="item flex-col">
        <h3 class="answer-title item-title" v-if="needEvidence">
          {{evidenceTypes[question.evidenceType]}}证据 ({{answer.evidences.length}})
        </h3>
        <template v-if="needEvidence">
          <div class="scrollView">
            <answer-file-list
            v-if="page.questionContainerElement"
            :question="question"
            :question-index="questionIndex"
            :files="answer.evidences"
            :prepend-files="prependFiles"
            :type="question.evidenceType"
            :disabled="disabled"
            :upload-data="uploadData"
            :get-lable-data="getLableData"
            :context-menu-container="page.questionContainerElement"
            @change="answerChange"
            @draw-saved="onDrawSaved"
            :datetime="orderDetail.userfinishtime"/>
          </div>
          <div v-if="question.evidenceType === 'qrcode' && page.sjfOrderDetail && page.sjfOrderDetail.qr_code_data.length > 0">
            <div v-for="code in page.sjfOrderDetail.qr_code_data"
                 style="display: inline-block; color: #E6A23C; width: 160px; margin-top: 12px;">
              <div><b>是否窜货：</b>{{code.crossGoods}}</div>
              <div><b>窜货原因：</b>{{code.verificationType}} <span v-if="code.verificationType === '跨省'">(SD省份：{{code.sdCodeProvinces.join(',')}})</span></div>
              <div><b>SD编码：</b>{{code.sdFranchiserCode}}</div>
              <div><b>SD名称：</b>{{code.sdFranchiserName}}</div>
            </div>
          </div>
        </template>
        <template v-else>
          <h3 class="answer-title item-title">
            照片证据
          </h3>
          <div class="center">无</div>
        </template>
      </div>
    <!-- 题目参考证据 -->
      <div class="item refer flex-col">
        <h3 class="answer-title item-title">审核参考</h3>
        <div class="scrollView" v-if="refers.length">
          <div v-for="refer of refers" :key="refer.index">
          <template v-if="answer.hasOwnProperty('text')">
            <div class="answer-title">
              答案参考
              <el-tag type="info"
                      size="mini">Q{{refer.index+1}} {{refer.question.title}}
              </el-tag>
              <el-tag v-show="refer.answer.isPassed === '10'"
                      type="info"
                      size="mini">未审核
              </el-tag>
              <el-tag v-show="refer.answer.isPassed === '20'"
                      type="success"
                      size="mini">已通过
              </el-tag>
              <el-tag v-show="refer.answer.isPassed === '30'"
                      type="danger"
                      size="mini">未通过
              </el-tag>
            </div>
            <answer-text
              :answer="refer.answer"
              :disabled="true"/>
          </template>
          <div class="answer-title">
            <!-- {{evidenceTypes[refer.question.evidenceType]}}参考 -->
            <el-tag type="info"
                    size="mini">Q{{refer.index+1}} {{refer.question.title}}
            </el-tag>
            <el-tag v-show="refer.answer.isPassed === '10'"
                    type="info"
                    size="mini">未审核
            </el-tag>
            <el-tag v-show="refer.answer.isPassed === '20'"
                    type="success"
                    size="mini">已通过
            </el-tag>
            <el-tag v-show="refer.answer.isPassed === '30'"
                    type="danger"
                    size="mini">未通过
            </el-tag>
          </div>
          <answer-file-list
            :question="question"
            :question-index="questionIndex"
            :prepend-files="refer.prependFiles"
            :files="refer.answer.evidences"
            :type="refer.question.evidenceType"
            :get-lable-data="getLableData"
            :disabled="true"/>
          </div>
        </div>
        <template v-if="!refers.length">
          <div class="center">无</div>
        </template>
      </div>
    </div>
    <!-- 题目备注 -->
    <question-comment
      :answer="answer"
      :disabled="disabled"/>
    <!-- 题目按钮 -->
    <question-review-button
      :id="question.id"
      :orderid="orderDetail.orderid"
      :status="orderDetail.status"
      :answer="answer"
      :disabled="disabled"
      :error-messages="errorMessages"/>
    <!-- 审核结果预测 -->
    <template v-if="page.questionMatchProduct[question.id]">
      <p style="color:#909399;margin-bottom: 0;font-size: 12px;">
        <template v-if="page.questionMatchProduct[question.id].isPassed===false">
          提示：已智能预测当前题目审核结果为不通过
        </template>
        <template v-if="page.questionMatchProduct[question.id].isPassed===true">
          提示：已智能预测当前题目审核结果为通过
        </template>
      </p>
    </template>
  </layout-panel>
</template>

<script>
import QuestionReview from '@views/question-review/question-review.js'
import QuestionDetail from '@views/question-review/packages/QuestionDetail'
import QuestionOption from '@views/question-review/packages/QuestionOption'
import AnswerText from '@views/question-review/packages/AnswerText'
import AnswerFileList from '@views/question-review/packages/AnswerFileList'
import QuestionReviewButton from '@views/question-review/packages/QuestionReviewButton'
import QuestionComment from '@views/question-review/packages/QuestionComment'
import { ANSWER_REVIEW_STATUS_NOT_PASSED } from '@views/question-review/question-review.constants'

export default {
  components: {QuestionDetail, QuestionOption, AnswerText, AnswerFileList, QuestionReviewButton, QuestionComment},
  mixins: [],
  inject: ['page'],
  props: {
    question: Object,
    questionIndex: Number,
    answer: Object,
  },
  data () {
    return {
      showBody: true,
      indexe: QuestionReview().getQuestion(this.question.id),
      types: {
        info: '文字题',
        text: '填空题',
        multitext: '多项填空题',
        select: '单选题',
        multiselect: '多选题',
        imageMultiselect: '图片多选题',
      },
      evidenceTypes: {
        photo: '照片',
        video: '视频',
        record: '录音',
        qrcode: '二维码'
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
      errorMessages: state => state.orderReview.errorMessages,
    }),
    ...Vuex.mapGetters('orderReview', [
      'allowModifyAnswer',
      'allowOrderReview',
      'allowOrderAppealReview',
    ]),
    prependFiles () {
      // 获得拼接的图片
      if (this.page.questionJoinImage[this.question.id]) {
        return [{
          src: this.page.questionJoinImage[this.question.id],
        }]
      }
      return []
    },
    isRereview () {
      return this.orderDetail.status === '40'
    },
    isJumped () {
      return this.indexe.isJumped
    },
    isOrderAppealReview () {
      return this.$route.meta.pageType === 'reviewOrderAppeal'
    },
    disabled () {
      // 工单申诉审核页：申诉中的工单允许编辑证据(补充申诉材料)
      if (this.isOrderAppealReview && this.allowOrderAppealReview) return false
      // 跳过 或者 不为复审和不允许审核的
      return this.isJumped || !(this.isRereview || this.allowModifyAnswer) || this.page.readonly === 'on'
    },
    refers () {
      let indexeList = QuestionReview().getReferQuestion(this.question.id)
      let refers = []
      indexeList.forEach((indexe) => {
        refers.push({
          index: indexe.index(),
          question: indexe.data,
          answer: indexe.answer,
          prependFiles: this.page.questionJoinImage[this.question.id] ? [{
            src: this.page.questionJoinImage[this.question.id],
          }] : [],
        })
      })
      return refers
    },
    needEvidence () {
      return QuestionReview().needEvidence(this.question.id)
    },
    uploadData () {
      const imgUrl = this.getExampleImageUrl()
      return {
        orderid: this.orderDetail.orderid,
        imgUrl: imgUrl,
        type: this.orderDetail.type
      }
    }
  },
  watch: {
    isJumped (val) {
      this.showBody = !val
    },
  },
  beforeCreate () {},
  created () {
    // 跳过的题目默认收起
    if (this.isJumped) {
      this.showBody = false
    }
    this.page.questionRefs.push(this)
    this.$nextTick(() => {
      QuestionReview().setQuestionElement(this.question.id, this.$el)
    })
  },
  mounted () {},
  methods: {
    ...Vuex.mapActions([]),
    answerChange () {
      // 修改答案重置审核
      if (this.allowOrderReview) {
        QuestionReview().emptyReviewed(this.question.id)
      }
    },
    onDrawSaved ({question, message}) {
      if (!question || question.id !== this.question.id) return
      QuestionReview().reviewNotPassed(this.question.id, message)
      this.$set(this.answer, 'isPassed', ANSWER_REVIEW_STATUS_NOT_PASSED)
      this.$set(this.answer, 'errorMessage', message)
      this.$forceUpdate()
    },
    // 文本变更
    answerTextChange (answer) {
      if (this.question.inputType && this.question.inputType === 'numberInt') {
        if (!new RegExp('^[0-9]*$').test(answer)) {
          this.$message.error('请输入整数')
        }
      } else if (this.question.inputType && this.question.inputType === 'numberFloat') {
        if (!(/^\d+(\.\d+)?$/.test(answer) || new RegExp('^[0-9]*$').test(answer))) {
          this.$message.error('请输入数字')
        }
      }
    },
    getLableData (src) {
      return request('findRecognitionResults', {order_id: this.orderDetail.orderid, url: src})
    },
    console (json) {
      console.log('question', json)
      console.log('questions', QuestionReview().questions)
      console.log('answer', QuestionReview().getAnswers())
      console.log('submit-answer', QuestionReview().getRecoveryAnswers(this.page))
    },
    // 获取一个示例的图片地址
    getExampleImageUrl () {
      // 先从当前题目找 没有找到 再从全部证据找
      const currentEvidence = this.question.evidence && this.question.evidence.find(evidence => evidence.type === 'photo')
      if (currentEvidence) {
        return currentEvidence.src
      }
      // 从全部证据找
      const templateResult = JSON.parse(this.orderDetail.templateresultjson)
      let evidenceItem = templateResult.find(evidence => evidence.photos && evidence.photos.length > 0)
      return evidenceItem ? evidenceItem.photos[0] : ''
    }
  },
}
</script>
<style lang="scss"
       scoped>
.question-audit-text {
  background-color: #f9fafc;
  padding: 10px;
  margin-top: 15px;
}

.answer-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .item {
    width: 49%;
    background-color: #e1f3fe;
    padding: 8px;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .refer {
    background-color: #f4f9f3;
  }
  .scrollView {
    max-height: 300px;
    overflow: scroll;
  }

  .flex-col {
    display: flex;
    flex-direction: column;
  }

  .center {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100px;
    font-size: 18px;
    font-weight: bold;
    color: #606266;
    flex: 1;
  }
  .item-title {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReviewQuestionPanel/OrderReviewQuestion.vue